module.exports = __webpack_public_path__ + "static/media/ferry.85d1d08f.png";